export default __webpack_public_path__ + "static/banner-2-ff0a51261b1b3b0a5924bdc97901fa09.png";